import type { PILOT_MODULATORS_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/pilot-modulators-card/pilot-modulators-card.fr.ts";

export const PILOT_MODULATORS_CARD_ENGLISH_LOCALE = {
  title: "Modulators",
} satisfies typeof PILOT_MODULATORS_CARD_FRENCH_LOCALE;
